module.exports = __webpack_public_path__ + "static/media/junte e troque - no seu ritmo.b8389559.png";